function renderWishlistContents(products) {
    let html = '';

    if (products.length) {
        products.forEach(wishlistProduct => {

            const remove_btn =
                      '<button type="button" onclick="removeFromWishlist(this)" class="close h7 remove_from_wishlist" data-title="' +
                      name +
                      '" data-id="' +
                      wishlistProduct.id +
                      '"><i class="icon-minus-circled h6" data-id="' +
                      wishlistProduct.id +
                      '"></i></button>';

            html += renderBoxProductEntry(wishlistProduct, remove_btn);
        });
    } else {
        html =
            '<p class="px-3 pt-3 pb-0 mb-1 font7-responsive">Du hast zurzeit nichts auf deinem Wunschzettel gespeichert.</p><p class="px-3 pb-3" style="font-size:11px;">(Um die Wunschliste zu pflegen, musst du angemeldet sein.)</p>';
    }

    document.querySelector('.JS_cartbox_fill_wishlist').innerHTML = html;
};

function renderBoxProductEntry(product, remove_btn) {
    let price          = '',
        condition      = '',
        article_number = '',
        html           = '';

    const css_class_with_id = `blue_item_${product.id}`;

    if (product.dealPrice) {
        price =
            '<small class="strong">nur</small> <span class="product_price">' +
            product.dealPrice +
            ' €</span> ' +
            '<small class="ml-3 strong">statt </small>' +
            '<div class="stroke-price"> ' +
            window.formatPrice(product.originalPrice, '€') +
            '</div>';
    } else {
        price = '<span class="product_price">' + window.formatPrice(product.currentPrice, '€') + '</span>';
    }

    condition = product.condition;
    article_number = product.cArtNr;

    const data_href = '/kaufen/info/' + product.name + '__' + product.id;
    html +=
        '<div class="wishListItem list-group list-group-flush pointerhover ' +
        css_class_with_id +
        '" data-href="' +
        data_href +
        '">';

    html +=
        '   <div class="list-group-item p-0 pt-3" data-products-id="' +
        product.id +
        '">' +
        '       <div class="d-flex px-3">' +
        '           <div class="col-3 px-0 mb-4 mr-2">' +
        '              <a href="' +
        data_href +
        '" title="zum Produkt">' +
        '               <img class="img-fluid maxh-6 mx-auto d-block" src="' +
        product.mainImage +
        '">' +
        '              </a>' +
        '           </div>' +
        '           <div class="flex-grow-1 mb-4 mr-2">' +
        '              <a href="' +
        data_href +
        '" title="zum Produkt">' +
        '               <div class="productsname h6 strong mb-0">' +
        product.name +
        '</div>' +
        '               <div class="products_prop font7-responsive mb-0">Zustand: <span class="strong">' +
        condition +
        '</span></div>' +
        '               <div class="productsnummer font7-responsive">Artikelnummer: ' +
        article_number +
        '</div>' +
        '               <div class="productsprice font6-responsive strong">' +
        price +
        '</div>' +
        '              </a>' +
        '           </div>' +
        '           <div class="mb-4">' +
        remove_btn +
        '</div>' +
        '       </div>' +
        '   </div>' +
        '</div>';

    return html;
}

window.fillWishlist = () => {

    window.axios.get('/api/wishlist/products')
        .then(productsData => {
            if (!productsData.data) {
                document
                    .querySelector('.JS_cartbox_fill_wishlist')
                    .innerHTML = '<h5 class="text-center">Noch nichts auf der Wunschliste.</h5>';

                return;
            }

            renderWishlistContents(productsData.data);
        });
};

window.removeFromWishlist = element => {

    const productId = element.dataset.id;

    window.axios.delete(`/api/wishlist/${productId}`)
          .then(()=> {
              window.useStore().dispatch('account/REMOVE_ITEM_FROM_WISHLIST',productId);
              element.closest('.wishListItem').remove();
          });
}
